import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';
import logoLight from '@/assets/logo-light.png';
import logoDark from '@/assets/logo-dark.png';

interface ThemedLogoProps {
  className?: string;
  alt?: string;
}

/**
 * Renders both logo variants stacked and crossfades between them based on theme.
 * Both images are preloaded by the bundler (ES imports) and rendered to the DOM,
 * so theme switches are instant — no network fetch, no flash.
 */
export function ThemedLogo({ className = "h-10 w-10 object-contain", alt = "CareOS" }: ThemedLogoProps) {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const isDark = mounted && resolvedTheme === 'dark';

  return (
    <span className={`relative inline-block ${className}`}>
      <img
        src={logoLight}
        alt={alt}
        aria-hidden={isDark}
        className="absolute inset-0 h-full w-full object-contain transition-opacity duration-200"
        style={{ opacity: isDark ? 0 : 1 }}
      />
      <img
        src={logoDark}
        alt={alt}
        aria-hidden={!isDark}
        className="absolute inset-0 h-full w-full object-contain transition-opacity duration-200"
        style={{ opacity: isDark ? 1 : 0 }}
      />
    </span>
  );
}
